import React from 'react';
import { valueNumbers } from '../data/content';
export function ValueNumbers() {
  const [lead, ...rest] = valueNumbers;
  return <section aria-label="What's in the bundle" className="border-y border-cream-line bg-paper" data-id="element-279" data-mp="2le3ml1o2pt96">
      <div className="mx-auto grid max-w-content gap-8 px-5 py-10 sm:px-8 lg:grid-cols-[1.3fr_2fr] lg:items-center lg:py-12" data-id="element-280" data-mp="2pedoa24u1xi8">
        <div className="flex items-end gap-4" data-id="element-281" data-mp="2uc5ix3wv3xq4">
          <span className="font-display text-[88px] leading-[0.85] text-coral sm:text-[104px]" data-id="element-282" data-mp="2ze4moewikwnl">{lead.value}</span>
          <span className="pb-2 text-lg font-bold leading-snug text-navy" data-id="element-283" data-mp="34b4uau90i7gt">
            {lead.label}
            <span className="block text-sm font-semibold text-ink-mute" data-id="element-284" data-mp="394frs4rxpbw2">Every message is different</span>
          </span>
        </div>
        <dl className="grid grid-cols-3 divide-x divide-cream-line" data-id="element-285" data-mp="3d6udcwmzmpr1">
          {rest.map(n => <div key={n.label} className="px-3 text-center first:pl-0 sm:px-6" data-id="element-286" data-mp="3i1zu7h1j9e89">
              <dt className="sr-only" data-id="element-287" data-mp="3n3735jfewjgi">{n.label}</dt>
              <dd className="font-display text-4xl leading-none text-navy sm:text-5xl" data-id="element-288" data-mp="2ne6vi80yabi4">{n.value}</dd>
              <dd className="mt-2 text-sm font-semibold leading-snug text-ink-soft" data-id="element-289" data-mp="2ie2nz7i0sr41">{n.label}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}